// Modal.js
import React, { useState, useEffect } from "react";
import "./Modal.css";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";

function Modal({ closeModal, productInfo }) {
  const { name, image, price } = productInfo;
  const [modalQuantity, setModalQuantity] = useState(1);
  const [totalPrice, setTotalPrice] = useState(price);
  const numericPrice = parseFloat(price.split(" ")[1]);

  useEffect(() => {
    // Update the total price whenever modalQuantity or price changes
    setTotalPrice(numericPrice * modalQuantity);

  }, [numericPrice, modalQuantity]);
  useEffect(() => {
    localStorage.setItem("totalprice",totalPrice)
  }, [totalPrice]);

  useEffect(() => {
    const storedQuantity = localStorage.getItem("quantity");
    if (storedQuantity) {
      setModalQuantity(parseInt(storedQuantity));
    }
  }, []);
  const handleModalIncrement = () => {
    setModalQuantity(modalQuantity + 1);
  };

  const handleModalDecrement = () => {
    if (modalQuantity > 1) {
      setModalQuantity(modalQuantity - 1);
    }
  };

 
  return (
    <div className="modal-container">
      <div className="modal-content">
        {/* <button className="close-btn" onClick={closeModal} style={{ marginLeft: '-80%', background: "#2a579b", color: 'white', border: 'none', cursor: 'pointer' }}>
          X
        </button> */}
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              paddingLeft: "3%",
              marginRight: "3%",
              borderBottom: "0.1px solid #1a1a1a80",
              paddingBottom: "2%",
            }}
          >
            <img
              src={image}
              alt="medicine"
              style={{ width: "10%", height: "4%" }}
            />
            <p
              style={{
                color: "#1a1a1a80",
                fontSize: "12px",
                marginTop: "-1px",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#1A1A1AE6",
                }}
              >
                Update quantity <br />
              </span>
              {name}
            </p>
            <RxCross2 style={{ fontSize: "22px",cursor:'pointer' }}  onClick={closeModal} />
          </Box>
          <p style={{marginTop:'8%',color: "#1a1a1a80",}}>Price Per Unit {price}</p>
          <Box>
            <div className="quantity-controls" >
              <RemoveOutlinedIcon
                style={{
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  background: "#fff",
                  padding: "5px",
                  borderRadius: "3px",
                  color: "grey",
                  borderRadius: "5px",
                  cursor:'pointer'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.background = "#f2f2f2"; // Change background on hover
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = "#fff"; // Reset background when not hovering
                }}
                onClick={handleModalDecrement}
              />
              <input
                type="number"
                value={modalQuantity}
                onChange={(e) => setModalQuantity(parseInt(e.target.value))}
                min={1}
                style={{ width: "15%",paddingTop:'1.8%',paddingBottom:'1.8%',marginTop:'-1px' }}
              />
              <AddOutlinedIcon  style={{
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  background: "#fff",
                  padding: "5px",
                  borderRadius: "3px",
                  color: "grey",
                  borderRadius: "5px",
                  cursor:'pointer'
                }}
                onClick={handleModalIncrement}

                onMouseOver={(e) => {
                  e.currentTarget.style.background = "#f2f2f2"; // Change background on hover
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = "#fff"; // Reset background when not hovering
                }} />
            </div>
          </Box>
          <p style={{color: "#1a1a1a80",}}>Total Price: Rs. {totalPrice}</p>
          <Link
          to={`/check-out?name=${name}&image=${image}&price=${price}&totalPrice=${totalPrice}`}
          style={{ textDecoration: "none", color: "white" }}
        >
          <button
            className="checkout"
            style={{
              background: "#2a579b",
              color: "#fff",
              width: "230px",
              height: "40px",
              border: "none",
              textAlign: "center",
              borderRadius: "10px",
              marginTop: "10%",
              cursor: "pointer",
            }}
           
          >
            CheckOut
          </button>
        </Link>
        </Box>

  
      
      </div>
    </div>
  );
}

export default Modal;
